<div class="container">
  <div class="logo-container">
    <div class="logo">
      <img width="205px" [src]="'../../../../../assets/Hayrick/logo/'+subdomain+'/logo-light.svg'" alt="hayrick logo" />
    </div>
  </div>

  <div class="card">
    <div class="logo-backBtn-container">
      <div class="back-btn-container">
        <div (click)="navBackBtn()" class="back-button">
          <img class="back-arrow-icon" src="../../../../assets//back-arrow.svg" alt="navigate back" />
        </div>
      </div>


    </div>

    <div class="text-container">
      <p class="text-1">LET'S GET STARTED</p>
      <p class="text-2">One-Time PIN</p>
      <p class="text-3">Please enter the One-Time-Password to verify your account</p>
    </div>

    <div class="otp-input-container">
      <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="otpConfig" #ngOtpInput></ng-otp-input>
    </div>

    <div *ngIf="otpTimer > 0; else showOtpResendButton" class="otp-countdown-txt-container">
      <p>Resend OTP in {{ countDownTimer$ | async }} seconds.</p>
    </div>

    <ng-template #showOtpResendButton>
      <div *ngIf="loginResponse$ | async as hasEmailAddress" class="resent-otp-mobile-btn">
        <button (click)="resendOtp(1)" class="resend-btn">Resend OTP - WhatsApp</button>
        <button (click)="resendOtp(2)" class="resend-btn">Resend OTP - Mobile</button>
        <div *ngIf="hasEmailAddress.userHasEmailAddress">
          <button (click)="resendOtp(3)" class="resend-btn">Resend OTP - Email</button>
        </div>
      </div>
    </ng-template>
  </div>
</div>
